/** @format */

import { post, download } from '@root/utils/httpWrap';

/**
 * 根据机构和商户类型查询商户列表
 */
export const getMerchantByOrgIdAndType = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchant/getMerchantByOrgIdAndType', params);
};
/**
 * 新增套餐
 */
export const addOrEditPackage = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackage/addOrEdit', params);
};
/**
 * 套餐列表
 */
export const packageList = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackage/list', params);
};
/**
 * 套餐停售
 */
export const offlinePackage = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackage/offline', params);
};
/**
 * 套餐详情
 */
export const editInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackage/editInfo', params);
};
/**
 * 根据机构查询商户
 */
export const getMerchantByOrgIdNotIncludeSon = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchant/getMerchantByOrgIdNotIncludeSon', params);
};
/**
 * 根据商户查询套餐
 */
export const listPackage = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackageRecord/listPackage', params);
};
/**
 * 套餐购买
 */
export const addMerchantPackageRecord = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackageRecord/add', params);
};
/**
 * 销售管理列表
 */
export const merchantPackageRecordList = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackageRecord/list', params);
};
/**
 * 销售管理列表导出
 */
export const merchantPackageRecordExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/merchantPackageRecord/export', params, fileName);
};
/**
 * 套餐余额列表
 */
export const merchantPackageAccountList = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackageAccount/list', params);
};
/**
 * 销售管理列表导出
 */
export const merchantPackageExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/merchantPackage/export', params, fileName);
};
/**
 * 套餐销售管理删除
 */
export const merchantPackageDelete = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackageRecord/delete', params);
};
/**
 * 商家套餐余额（导出）
 * @param params
 */
export const merchantAccountExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/merchantPackageAccount/export', params, fileName);
};
/**
 * 套餐管理编辑检验该套餐是否可编辑
 * @param params
 */
export const editCheck = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantPackage/editCheck', params);
};
